import React from 'react';
import Carousel from 'components/atoms/Carousel';
import CommentCard, { CommentCardProperty } from 'components/atoms/CommentCard';
import useMedia from 'util/hook/useMedia';

interface CommentsCarouselProperty {
	data: CommentCardProperty[];
	className?: string;
}

const CommentsCarousel: React.FC<CommentsCarouselProperty> = ({ data, className }) => {
	const media = useMedia();
	return (
		<>
			{media === 'desktop' && (
				<Carousel
					widthOfItem={320}
					marginBetweenItems={40}
					Component={CommentCard}
					data={data}
					automatic="left"
					animation="normal"
					heightOfCarousel={430}
					className={className}
				/>
			)}
			{media === 'mobile' && (
				<Carousel
					widthOfItem={240}
					marginBetweenItems={24}
					Component={CommentCard}
					data={data}
					automatic="left"
					animation="normal"
					heightOfCarousel={450}
					className={className}
				/>
			)}
		</>
	);
};

export default CommentsCarousel;
